import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import { InfoCircleFilled } from "@ant-design/icons";
import React from "react";
import OrderTab from "../../enum/OrderTab";

interface HistoryOrderHintProps {
    shop: ShopDTO;

    tab: OrderTab;

    className?: string;
}

const hideHintShopTypes = [
    ...SupplierShopTypes,
    ShopType.MANUAL,
    ShopType.INDEPENDENT_MANUAL,
    ShopType.PDD_FDS,
    ShopType.PDD_FULFILLMENT,
    ShopType.ALIBABA_SUPPLIER,
    ShopType.DOUDIAN_IOP,
    ShopType.KWAI_DROPSHIP,
    ShopType.CHANNEL_SHOP_DROPSHIP,
    ShopType.CHANNEL_SHOP_SUPPLIER,
];

const showHintTabs = [OrderTab.SUCCESS, OrderTab.CANCELED];

const HistoryOrderHint: React.FC<HistoryOrderHintProps> = function (props) {
    const { shop, tab, className } = props;

    if (hideHintShopTypes.includes(shop.type) || !showHintTabs.includes(tab)) return null;

    if (ShopType.WEBUY === shop.type) {
        return (
            <span className={className}>
                注意：由于鲸灵平台接口能力限制，接口无法同步“已完成”状态订单，发货易会自动将发货时间超过15天的订单变为“已完成”状态
            </span>
        );
    }

    if ([ShopType.AIKUCUN, ShopType.AIKUCUN_V2].includes(shop.type)) {
        return (
            <span className={className}>
                注意：由于爱库存平台接口能力限制，接口无法同步“已完成”状态订单，发货易会自动将发货时间超过15天的订单变为“已完成”状态
            </span>
        );
    }

    let url = "";

    switch (shop.type) {
        case ShopType.TAOBAO:
            url =
                "https://trade.taobao.com/trade/itemlist/list_sold_items.htm?action=itemlist/SoldHisQueryAction&event_submit_do_query=1&tabCode=before3Months&";
            break;
        case ShopType.PINDUODUO:
            url = "https://mms.pinduoduo.com/orders/list/old";
            break;
        case ShopType.DOUDIAN:
            url = "https://fxg.jinritemai.com/ffa/morder/order/list";
            break;
        case ShopType.ALIBABA:
            url = "https://trade.1688.com/order/seller_order_list.htm";
            break;
        case ShopType.KWAI:
            url = "https://s.kwaixiaodian.com/zone-origin/order/list";
            break;
        case ShopType.JD:
            url = "https://porder.shop.jd.com/order/orderlist/threeMonthAgo";
            break;

        case ShopType.JD_PURCHASE:
            url = "https://gongxiao.jd.com/vender/orderList?menuId=115475747";
            break;
        default:
            break;
    }

    return (
        <span className={className}>
            <InfoCircleFilled className="mr5 warn" />
            更多历史订单请前往
            {url ? (
                <a href={url} target={url}>
                    商家后台
                </a>
            ) : (
                "商家后台"
            )}
            查看
        </span>
    );
};

export default React.memo(HistoryOrderHint);
